// extracted by mini-css-extract-plugin
module.exports = {"container":"SnapButton_container___DPkz"};